// @flow

import type {TreeStructure} from '@pb/kit-component-tree-v2';

type CheckParentArgs = {
    checkedIdsList: Array<string>,
    id: string,
    parentId: ?string,
    checked: boolean,
    data: TreeStructure,
};

export const checkParent = ({checkedIdsList, id, checked, parentId, data}: CheckParentArgs): Array<string> => {
    const updatedCheckedIdsList = [].concat(checkedIdsList);

    const checker = (tree: TreeStructure) => {
        return tree.map(item => {
            if (item.id === id) {
                return checked;
            }
            if (item.children) {
                const isAllChildrenChecked = checker(item.children).every(i => i);
                const itemIndex = updatedCheckedIdsList.indexOf(item.id);
                if (isAllChildrenChecked && itemIndex < 0) {
                    updatedCheckedIdsList.push(item.id);
                } else if (!isAllChildrenChecked && itemIndex > -1) {
                    updatedCheckedIdsList.splice(itemIndex, 1);
                }
            }
            return item.transient ? true : updatedCheckedIdsList.includes(item.id);
        });
    };

    const subTree = parentId && data.find(i => i.id === parentId);
    if (subTree) {
        checker([subTree]);
    }

    return updatedCheckedIdsList;
};
